import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Login from '../../components/Login/login';
import Register from '../../components/Register/register';

const Loginpage = () => {
    const [isRegister, setIsRegister] = useState(false); // State to toggle between Login and Register

    return (
        <div>
            <Container fluid>
                <Row>
                    <Col>
                        {isRegister ? (
                            <Register setIsRegister={setIsRegister} />
                        ) : (
                            <Login setIsRegister={setIsRegister} />
                        )}
                    </Col>
                </Row>
                <Row>
                </Row>
            </Container>
            
        </div>
    );
};

export default Loginpage;
